import { Helmet } from 'react-helmet-async';

import { Content, Header, Heading, Layout } from '@eluve/components';

import { TenantsList } from './components/TenantsList';

export const TenantsPage = () => {
  return (
    <Layout type="simple">
      <Helmet>
        <title>Select an Organization | Eluve</title>
      </Helmet>
      <Header>
        <div className="my-2 py-2">
          <Heading>Select an Organization</Heading>
        </div>
      </Header>
      <Content padded>
        <TenantsList />
      </Content>
    </Layout>
  );
};
